// Direct imports so only these 14 section renderers (and their deps) are on the critical path.
// Importing from '../components' (barrel) would pull in all 33 exports and increase __clientHydrationTime.
import { BannerCarouselComponent } from '../components/banner-carousel';
import { BentoCardsContainerComponent } from '../components/bento-cards-container';
import { BrandSpotlightComponent } from '../components/brand-spotlight';
import { FooterComponent } from '../components/footer';
import { FireworkComponent } from '../components/firework';
import { GalleryCardScrollerComponent } from '../components/gallery-card-scroller';
import { HeaderGroupComponent } from '../components/header-group';
import { MediaIabComponent } from '../components/media-iab-component';
import { MediaShoppableDisplayComponent } from '../components/media-shoppable-display-component';
import { MenuTileCarouselComponent } from '../components/menu-tile-carousel';
import { MiniInfoCardContainerComponent } from '../components/mini-info-card-container';
import { ProductCarouselComponent } from '../components/product-carousel';
import { ProvinceSelectorComponent } from '../components/province-selector';
import { VerticalFeatureCardComponent } from '../components/vertical-feature-card';

/**
 * Hook to retrieve the renderer map for SDM SDUI.
 */
export const useRendererMapSSR = () => {
  return {
    provinceListComponent: ProvinceSelectorComponent,
    bannerCarouselComponent: BannerCarouselComponent,
    bentoCardContainerComponent: BentoCardsContainerComponent,
    verticalFeatureCardContainerComponent: VerticalFeatureCardComponent,
    productCarouselComponent: ProductCarouselComponent,
    menuTileCarouselComponent: MenuTileCarouselComponent,
    fireworkComponent: FireworkComponent,
    mediaIABComponent: MediaIabComponent,
    mediaShoppableDisplayComponent: MediaShoppableDisplayComponent,
    brandSpotlightComponent: BrandSpotlightComponent,
    miniInfoCardContainerComponent: MiniInfoCardContainerComponent,
    footerContentComponent: FooterComponent,
    galleryScrollerComponent: GalleryCardScrollerComponent,
    headerGroupComponent: HeaderGroupComponent,
  };
};

export default useRendererMapSSR;

// TODO:  Add mock data, you got it from Notion doc (JSON ReSPONSE)
// TODO: Setup SDM app and test component
